import { Directive, ElementRef, inject, OnDestroy, OnInit } from '@angular/core';
import { Subject, filter, fromEvent, takeUntil, tap } from 'rxjs';

@Directive({
    selector: '[appSuspendEnter]',
    standalone: true,
})
export class SuspendEnterDirective implements OnInit, OnDestroy {
    private unsubscribe$: Subject<void> = new Subject<void>();

    private readonly elementRef = inject<ElementRef>(ElementRef);

    public ngOnInit(): void {
        this.subscribeForKeyDownEvent();
    }

    public ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    private subscribeForKeyDownEvent(): void {
        let suspendDefault = true;
        fromEvent(this.elementRef.nativeElement, 'keydown')
            .pipe(
                tap((e: KeyboardEvent) => {
                    if (e.key !== 'Enter') {
                        suspendDefault = true;
                    }
                }),
                filter((e: KeyboardEvent) => e.key === 'Enter'),
                takeUntil(this.unsubscribe$),
            )
            .subscribe((e: KeyboardEvent) => {
                if (suspendDefault) {
                    e.preventDefault();
                }
                suspendDefault = false;
            });
    }
}
